const FACE_DISPO = {
  title: 'Visualisation des faces disponibles - S{week}',
  breadcrumb: {
    racine: 'Accueil',
    listeDemande: 'Liste des demandes affichages',
    restriction: 'Visualisation des faces disponibles',
  },
  actions: {
    actionAffichage: 'Action d\'affichage',
    instructionPose: 'Instruction de pose',
    laisserEnPlace: 'Laisser en place',
    enleverLaisserEnPlace: 'Enlever le laisser en place',
    affecterListeAffichage: 'Affecter à une liste d\'affichage',
  },
};

export default FACE_DISPO;
